const ACCENTS: Record<string, string> = {
  blue: 'bg-blue-500/10 dark:bg-blue-500/20 text-blue-600 dark:text-blue-400',
  violet: 'bg-violet-500/10 dark:bg-violet-500/20 text-violet-600 dark:text-violet-400',
  emerald: 'bg-emerald-500/10 dark:bg-emerald-500/20 text-emerald-600 dark:text-emerald-400',
  amber: 'bg-amber-500/10 dark:bg-amber-500/20 text-amber-600 dark:text-amber-400',
  rose: 'bg-rose-500/10 dark:bg-rose-500/20 text-rose-600 dark:text-rose-400',
  sky: 'bg-sky-500/10 dark:bg-sky-500/20 text-sky-600 dark:text-sky-400',
  teal: 'bg-teal-500/10 dark:bg-teal-500/20 text-teal-600 dark:text-teal-400',
  indigo: 'bg-indigo-500/10 dark:bg-indigo-500/20 text-indigo-600 dark:text-indigo-400',
  primary: 'bg-primary-500/10 dark:bg-primary-500/20 text-primary-600 dark:text-primary-400',
};

export function accentClasses(accent: string): string {
  return ACCENTS[accent] ?? ACCENTS['primary'];
}
